import React, { Component } from 'react';
import queryString from 'query-string';
import ApiClient from './Api';
import MenuLayer from './MenuLayer';
import TagManager from 'react-gtm-module'
import escapeHtml from 'escape-html';

import { DisableSingleTouch } from './MapUtils';
import { TESTIMONIAL_CHOICES } from './TestimonialWizard';

import markerAnimaux from './assets/marker-animaux.png';
import markerChangement from './assets/marker-changement.png';
import markerInquietude from './assets/marker-inquietude.png';
import markerLogement from './assets/marker-logement.png';
import markerPaysage from './assets/marker-paysage.png';
import markerPlantes from './assets/marker-plantes.png';
import markerRevenu from './assets/marker-revenu.png';
import markerSante from './assets/marker-sante.png';
import markerVieQuotidenne from './assets/marker-vie-quotidienne.png';

import pictoAnimaux from "./assets/picto-animaux.png";
import pictoChangement from "./assets/picto-changement.png";
import pictoInquietude from "./assets/picto-inquietude.png";
import pictoLogement from "./assets/picto-logement.png";
import pictoPaysage from "./assets/picto-paysage.png";
import pictoPlantes from "./assets/picto-plantes.png";
import pictoRevenu from "./assets/picto-revenu.png";
import pictoSante from "./assets/picto-sante.png";
import pictoVieQuotidienne from "./assets/picto-vie-quotidienne.png";

export const MARKERS = {
  'avenir': markerInquietude,
  'mode-vie': markerChangement,
  'sante': markerSante,
  'revenu': markerRevenu,
  'logement': markerLogement,
  'quotidien': markerVieQuotidenne,
  'plante': markerPlantes,
  'animaux': markerAnimaux,
  'paysage': markerPaysage,
};

export const PICTO = {
  'animaux': {'picto': pictoAnimaux, 'title': 'Perturbations sur les animaux'},
  'mode-vie': {'picto': pictoChangement, 'title': 'Ça m\'a fait changer mon mode de vie'},
  'avenir': {'picto': pictoInquietude, 'title': 'Angoissé·e par rapport à l\'avenir'},
  'logement': {'picto': pictoLogement, 'title': 'Sur mon logement'},
  'paysage': {'picto': pictoPaysage, 'title': 'Perturbations sur les paysages'},
  'plante': {'picto': pictoPlantes, 'title': 'Perturbations sur les plantes'},
  'revenu': {'picto': pictoRevenu, 'title': 'Sur mes revenus'},
  'sante': {'picto': pictoSante, 'title': 'Sur ma santé'},
  'quotidien': {'picto': pictoVieQuotidienne, 'title': 'Dans ma vie quotidienne'}
};


export const DEFAULT_MARKER = markerInquietude;

const api = new ApiClient();


export default class ContribsMap extends Component {

  constructor(props) {
    super(props);
    this.state = {
      popinDisplayed: true,
      // Store initial query string (for utm_* parameters)
      initialQS: props.location ? queryString.parse(props.location.search) : '',
      layerNames: this.generateLayerNames()
    };
    this.map = null;
  }

  hideLayer = (layerId) => {
    this.map.setLayoutProperty(layerId, 'visibility', 'none');
  }

  showLayer = (layerId) => {
    this.map.setLayoutProperty(layerId, 'visibility', 'visible');
  }

  generateLayerNames() {
    let layers = {};
    let layer_icon = null;
    for (let [t, {major_choices}] of Object.entries(TESTIMONIAL_CHOICES)) {
      for (let [r, {icon}] of Object.entries(major_choices)) {
        if (icon && MARKERS[icon]) {
            layer_icon = icon;
        } else {
          layer_icon = 'default';
        }
        const layerId = `contribs-${t}-${r}`;
        layers[layer_icon] = {
          'layerId': layerId,
          't': t,
          'r': r
        }
      }
    }
    return layers
  }

  clickOnContribHandler = () => (e) => {
    var feat = e.features[0];
    var coordinates = feat.geometry.coordinates.slice();
    var contribId = feat.properties.id != null ? feat.properties.id : '';

    let elementHtmlId = 'gp-contrib-content-' + contribId,
      description = '<div id="' + elementHtmlId + '"></div>';

    // From mapbox example:
    // Ensure that if the map is zoomed out such that multiple
    // copies of the feature are visible, the popup appears
    // over the copy being pointed to.
    while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
      coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
    }

    // Set popup constraints if on mobile or tablet
    let maxWidth = window.innerWidth > 768 ? 'none' : '240px';
    let twitterOptions = window.innerWidth > 768 ? {lang: 'fr'} : {lang: 'fr', width: 240};

    if (contribId !== '') {
      const popup = new window.mapboxgl.Popup({maxWidth: maxWidth, anchor: 'center'})
        .setLngLat(coordinates)
        .setHTML(description)
        .addTo(this.map);

      const tagManagerClickOnMarkerArgs = {
        dataLayer: {
          event: "standard",
          eventCategory: "carte-soutien",
          eventAction: "click",
          eventLabel: "clic sur la contribution " + contribId
        },
        dataLayerName: 'PageDataLayer'
      }
      TagManager.dataLayer(tagManagerClickOnMarkerArgs);

      // console.log('Creating regular popup contents...')

      api.getContrib(contribId).then((data) => {

        let mapPopupMoreClick = function(event) {
          // will be used as listener for the click on the "see more" link
          if (event) {
            event.preventDefault();
          }
          this.props.onContribDetail(data);
          popup.remove();
        }.bind(this);

        let message = data.message;
        const isTooLong = message.length >= 200;
        if (message.length >= 200) {
          message = message.substring(0, 200) + '…';
        }

        const body = `
          <div class="gp-contrib-name">${escapeHtml(data.name)}</div>
          <div class="gp-contrib-message">«&nbsp;${escapeHtml(message)}&nbsp;»</div>
          <a class="gp-contrib-message-more" href="">Voir plus</a>
        `;
        let element = document.getElementById(elementHtmlId);
        element.innerHTML = body;
        let link = element.getElementsByClassName("gp-contrib-message-more")[0];
        if (link) {
          link.addEventListener("click", mapPopupMoreClick);
        }
      }).catch((error) => {
        if (error.response.status === 404) {
          // contrib may have been moderated since last mapbox upload
          console.log(error);
        } else {
          throw error;
        }
      });
    }

  }


  addContribLayer = (layerId, t, r, icon) => {
    this.map.addLayer({
      id: layerId,
      type: 'symbol',
      source: 'points',
      "source-layer": "contribs",
      filter: [
        "all",
        ["==", "t", parseInt(t)],
        ["==", "r", parseInt(r)],
      ],
      layout: {
        "icon-image": icon,
        "icon-size": 0.5,
        "icon-anchor": "bottom",
        "icon-allow-overlap": true
      }
    });
    this.map.on('mouseenter', layerId, () => {
      this.map.getCanvas().style.cursor = 'pointer';
    });
    // Change it back to a pointer when it leaves.
    this.map.on('mouseleave', layerId, () => {
      this.map.getCanvas().style.cursor = '';
    });
    this.map.on('click', layerId, this.clickOnContribHandler());
  }


  componentDidMount() {
    const { bounds, onContribDetail } = this.props;
    if (window.mapboxgl) {
      window.mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
      this.map = new window.mapboxgl.Map({
        container: 'gp-map', // container id
        style: 'mapbox://styles/mapbox/streets-v11', // stylesheet location
        bounds: bounds
      });
      this.map.onContribDetail = onContribDetail;


      this.map.addControl(new window.mapboxgl.NavigationControl(), 'bottom-right');
      this.map.addControl(new DisableSingleTouch());

      this.map.on('load', () => {
        this.map.setLayoutProperty(
          'country-label', 'text-field', ['get', 'name_fr']
        );
        // https://docs.mapbox.com/mapbox-gl-js/example/add-image/
        // We use the inline data image built by webpack.
        // If we run into load problems, we can still move the icon to "public" and use process.env.PUBLIC_URL + 'Pointeur-couleur.png'
        this.map.loadImage(DEFAULT_MARKER, (error, image) => {
          if (error) throw error;
          this.map.addImage('default', image);
          api.getLayer('contribs').then((data) => {
            this.map.addSource('points', {
              type: 'vector',
              url: `mapbox://${data.tileset}`
            });

            for (let [icon, layer] of Object.entries(this.state.layerNames)) {
              if (icon && MARKERS[icon]) {
                  this.map.loadImage(MARKERS[icon], (err, image) => {
                    if (err) throw err;
                    this.map.addImage(icon, image);
                  });
                }
              this.addContribLayer(layer.layerId, layer.t, layer.r, icon);
            }
          });
          this.map.addSource('newly-added-point', {
            type: 'geojson',
            data: {"type": "FeatureCollection", "features": []}
          });
          this.map.addLayer({
            id: 'newly-added-contrib',
            type: 'symbol',
            source: 'newly-added-point',
            layout: {
              "icon-image": "default",
              "icon-size": 0.5,
              "icon-anchor": "bottom"
            }
          });
          // https://docs.mapbox.com/mapbox-gl-js/example/popup-on-click/
          this.map.on('click', 'newly-added-contrib', this.clickOnContribHandler());
        });
      });
      window.map = this.map;
    }
  }

  componentDidUpdate(prevProps) {
    // fit new bounds if changed
    if (this.props.bounds !== prevProps.bounds) {
      this.map.fitBounds(this.props.bounds);
    }
    this.map.onContribDetail = this.props.onContribDetail;
  }

  onPopupClose = () => {
    this.setState({popinDisplayed: false});
  }

  onButtonClick = () => {
    this.setState({popinDisplayed: true});
  }

  render() {
    return (
        <div>
          <div id="gp-map"/>
          <MenuLayer layerNames={this.state.layerNames} activateCallBack={this.showLayer} disableCallBack={this.hideLayer}/>
        </div>
    );
  }
}
